import React, { useEffect, useState } from 'react';
import css from '../../../../styles/modules/TransferDetails/transferdetails.module.css';
import { allStates } from '../../lib/allStates';
import { NumericFormat } from 'react-number-format';
import amountErrorState from '../../lib/form/amountErrorState';
import {
  setAmount,
  setCity,
  setReAmount,
  setZip,
  setStreet,
  setStreet2,
  setStateLocale,
  setNotes,
  setOffice,
} from '../../../../reducers/components/TransferDetails/FormActions';
import { useSelector, useDispatch } from 'react-redux';

export default function SubmissionForm({
  tenant,
  fieldOffices,
  transferData,
  maximumAmount,
}) {
  const { routingType } = tenant;

  const dispatch = useDispatch();
  const {
    amount,
    reAmount,
    city,
    street,
    street2,
    stateLocale,
    zip,
    notes,
    fieldOffice,
  } = useSelector((state) => state.clientTransferForm);

  const [officeBlur, setOfficeBlur] = useState(null);
  const officeError = !fieldOffice;

  const submissionProps = {
    amount,
    reAmount,
    city,
    stateLocale,
    zip,
    street1: street,
    street2: street2,
    notes,
  };

  const err = amountErrorState(submissionProps, maximumAmount);
  //------init--------

  // useEffect(
  //     () =>
  //       initDefaultValues(
  //         transferData,
  //         setSubmissionProps
  //       ),
  //     [transferData],
  //   );
  useEffect(() => {
    if (transferData) {
      dispatch(setAmount(Number(transferData?.amount)));
      dispatch(setReAmount(Number(transferData?.amount)));
      dispatch(setCity(transferData.propertyCity));
      dispatch(setStateLocale(transferData.propertyState));
      dispatch(setZip(transferData.propertyZipcode));
      dispatch(setStreet(transferData.propertyAddress1));
      dispatch(setStreet2(transferData.propertyAddress2));
      dispatch(setNotes(transferData.notes));
      // dispatch(setOffice(transferData))
    }
  }, [transferData]);

  function handleInputChange(e) {
    const { id, value, name } = e.target;

    switch (id || name) {
      case 'amount':
        dispatch(setAmount(value));

        break;
      case 'reAmount':
        dispatch(setReAmount(value));

        break;
      case 'street':
        dispatch(setStreet(value));

        break;
      case 'street2':
        dispatch(setStreet2(value));
        break;
      case 'city':
        dispatch(setCity(value));

        break;
      case 'zip':
        dispatch(setZip(value));

        break;
      case 'states':
        dispatch(setStateLocale(value));

        break;
      case 'notes':
        dispatch(setNotes(value));
        break;
      default:
        return;
    }
  }

  const handleOfficeChange = (e) => {
    console.log(fieldOffices);
    const office = fieldOffices.find((office) => office._id === e.target.value);
    dispatch(setOffice(office));
  };

  return (
    <>
      <div className={css.amountFieldContainer}>
        <div className={css.subWrapper}>
          <h5 className={css.label}>Amount</h5>
          <div className={css.textFieldSub}>
            <div className={css.inputContainer}>
              <p
                style={err.error ? { color: '#B3261E' } : null}
                className={css.tagLabel}
              >
                * Amount
              </p>
              <NumericFormat
                data-testid="amount"
                id="amount"
                value={amount}
                onValueChange={(e) => {
                  // adds target to this component's event
                  e.target = {
                    id: 'amount',
                    value: e.value,
                  };
                  handleInputChange(e);
                }}
                className={err.error ? css.amountFieldsError : css.amountFields}
                thousandSeparator
                isNumericString
                decimalScale={2}
                fixedDecimalScale
                prefix="$"
              />
              <p style={{ opacity: 0 }} className={css.errorMsg}>
                {err.msg}
              </p>
            </div>
            <div className={css.inputContainer}>
              <p
                style={err.error ? { color: '#B3261E' } : null}
                className={css.tagLabel}
              >
                * Re-Enter Amount
              </p>
              <NumericFormat
                data-testid="reAmount"
                id="reAmount"
                value={reAmount}
                onValueChange={(e) => {
                  // adds target to this component's event
                  e.target = {
                    id: 'reAmount',
                    value: e.value,
                  };
                  handleInputChange(e);
                }}
                className={err.error ? css.amountFieldsError : css.amountFields}
                thousandSeparator
                isNumericString
                decimalScale={2}
                fixedDecimalScale
                prefix="$"
              />
              <p
                style={!err.error ? { opacity: 0 } : null}
                className={css.errorMsg}
              >
                {err.msg}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className={css.amountFieldContainer} style={{ marginTop: 24 }}>
        <div className={css.subWrapper}>
          <h5 className={css.label}>Property Address & Notes</h5>
          <div className={css.textFieldSub2}>
            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabel}>* Street Address</p>
                <input
                  data-testid="street-1"
                  id="street"
                  onChange={handleInputChange}
                  value={street}
                  className={css.textFieldFullWidth}
                />
              </div>

              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabel}>Unit # / Apt #</p>
                <input
                  data-testid="street-2"
                  id="street2"
                  onChange={handleInputChange}
                  value={street2}
                  className={css.textFieldFullWidth}
                />
              </div>
              <p className={css.street2Extra}>Apt #, Suite, etc.</p>
            </div>

            <div className={css.citySubTextFieldContainer}>
              <div className={css.inputContainer}>
                <p className={css.tagLabel}>* City</p>
                <input
                  data-testid="city"
                  id="city"
                  onChange={handleInputChange}
                  value={city}
                  className={css.amountFields}
                />
              </div>

              <div className={css.zipContainer}>
                <p className={css.tagLabel}>* State</p>
                <select
                  data-testid="state"
                  onChange={handleInputChange}
                  className={css.stateDropdown}
                  name="states"
                  id="states"
                >
                  <option value={stateLocale || null}>
                    {stateLocale || null}
                  </option>
                  {allStates.map((option, index) => (
                    <option key={index} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>

              <div className={css.zipContainer}>
                <p className={css.tagLabel}>* Zip</p>
                <input
                  data-testid="zip"
                  id="zip"
                  onChange={handleInputChange}
                  value={zip}
                  className={css.amountFields}
                />
              </div>
            </div>
            <div className={css.fullWidthFieldContainer}>
              <div className={css.inputContainerFullWidth}>
                <p className={css.tagLabel}>Notes</p>
                <textarea
                  data-testid="notes"
                  id="notes"
                  onChange={handleInputChange}
                  value={notes}
                  className={css.textFieldNotes}
                  rows={5}
                />
              </div>
            </div>
          </div>
        </div>
        {routingType?.toLowerCase() === 'office' && (
          <div className={css.amountFieldContainer} style={{ marginTop: 24 }}>
            <div className={css.subWrapper}>
              <h5 className={css.label}>Field Office</h5>
              <div className={css.textFieldSub2}>
                <div className={css.fullWidthFieldContainer}>
                  <div className={css.inputContainerFullWidth}>
                    <p
                      className={css.tagLabel}
                      style={officeError ? { color: '#B3261E' } : null}
                    >
                      * Office
                    </p>
                    <select
                      className={
                        officeError ? css.amountFieldsError : css.amountFields
                      }
                      onChange={handleOfficeChange}
                      onBlur={() => setOfficeBlur(true)}
                    >
                      <option value={null}></option>
                      {fieldOffices?.map((office, index) => {
                        return (
                          <option key={office._id + index} value={office._id}>
                            {office.title +
                              ' - ' +
                              office.city +
                              ', ' +
                              office.state}
                          </option>
                        );
                      })}
                    </select>
                    <p
                      style={!officeError ? { opacity: 0 } : null}
                      className={css.errorMsg}
                    >
                      Office is required.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
